import { Stack, Typography } from "@mui/material";
import type { WordCountProps } from "./types";

const createRemainingMessage = (
  used: number,
  maximum: number,
  unit: string,
) => {
  const remaining = maximum - used;
  if (remaining === 1) return `${remaining.toLocaleString()} word remaining`;
  if (remaining >= 0) return `${remaining.toLocaleString()} ${unit} remaining`;
  if (remaining === -1)
    return `${Math.abs(remaining).toLocaleString()} word over limit`;
  return `${Math.abs(remaining).toLocaleString()} ${unit} over limit`;
};

function WordCountMessage({ count, maxWords, error }: WordCountProps) {
  if (!maxWords) return null;

  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      {maxWords ? (
        <Typography
          variant="caption"
          color={error ? "error" : "text.secondary"}
        >
          {createRemainingMessage(count, maxWords, "words")}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default WordCountMessage;
